import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { _get, _put } from "../../Services/baseApi";
import {
    NOTIFICATION_GET_URL,
    NOTIFICATION_PUT_URL,
} from "../../Services/endpoints";
import { errorHandler } from "../../Utils/toast";

const initialState = {
    isLoading: false,
    notifications: [],
    hasUnread: false,
    page: 0
};

const notificationsSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        resetNotification(state) {
            state.notifications = [];
            state.page = 0;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getNotificationThunk.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getNotificationThunk.fulfilled, (state, { payload }) => {
                if (payload && payload.findNotifications) {
                    const newNotifications = payload.findNotifications;

                    if (payload.page === 1) {
                        // First page - replace all notifications
                        state.notifications = newNotifications;
                        state.page = 1;
                        state.hasMoreData = newNotifications.length > 0;
                    } else if (payload.page > state.page) {
                        // Subsequent pages - append notifications
                        if (newNotifications.length > 0) {
                            state.notifications = [...state.notifications, ...newNotifications];
                            state.page = payload.page;
                            state.hasMoreData = true;
                        } else {
                            // Empty array means no more data
                            state.hasMoreData = false;
                        }
                    }

                    // Check for unread notifications
                    const hasUnreadNotification = state.notifications.some(item => item.isRead === false);
                    state.hasUnread = hasUnreadNotification;

                    // Optional: Update total count if API provides it
                    if (payload.totalCount !== undefined) {
                        state.totalCount = payload.totalCount;
                        // Alternative way to check if more data is available
                        state.hasMoreData = state.notifications.length < payload.totalCount;
                    }
                }
                state.isLoading = false;
            })
            .addCase(getNotificationThunk.rejected, (state) => {
                state.isLoading = false
            });

        // update notification
        builder
            .addCase(updateNotificationThunk.pending, () => {
                // state.isLoading = true;
            })
            .addCase(updateNotificationThunk.fulfilled, (state) => {
                state.page = 0;
                state.notifications = []
                state.hasUnread = false;
                state.isLoading = false
            })
            .addCase(updateNotificationThunk.rejected, (state) => {
                state.isLoading = false
            });
    },
});

export default notificationsSlice.reducer;

export const { resetNotification } = notificationsSlice.actions

export const getNotificationThunk = createAsyncThunk(
    "notification/getNotificationThunk",
    async (payload) => {
        try {
            const response = await _get(NOTIFICATION_GET_URL, {
                page: payload?.page || undefined,
                limit: payload?.limit || undefined,
                keyOrder: payload?.key && payload?.keyOrder ? payload?.keyOrder : undefined,
            });
            return response?.data?.data;
        } catch (error) {
            errorHandler(error);
        }
    }
);

export const updateNotificationThunk = createAsyncThunk(
    "notification/updateNotificationThunk",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await _put(NOTIFICATION_PUT_URL, payload);
            if (payload?.onSuccess) {
                payload.onSuccess()
            }
            return response?.data?.data;
        } catch (error) {
            errorHandler(error);
            rejectWithValue(error);
        }
    }
);
